@use '@/styles/tokens' as *;

.header {
  display: flex;
  // Reserve the toolbar's control height, so a hub's title-only header and its page's
  // title+toolbar header are the same height and the toolbar arriving does not shift the tabs.
  min-height: 40px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.title {
  margin: 0;
  font-family: var(--font-family-heading);
  font-size: 28px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
